import { Component, Input } from '@angular/core';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover.result';
import {
  RolloverPropertyTransferredResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover-property-transferred.result';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';

@Component({
  selector: 'app-rollover-inventory-result',
  templateUrl: './rollover-inventory-result.component.html',
  styleUrls: ['./rollover-inventory-result.component.scss'],
  standalone: false,
})
export class RolloverInventoryResultComponent {

  @Input()
  options: RolloverOptions;
  @Input()
  results: RolloverResult;
  @Input()
  propertyTransferredOptions: RolloverPropertyTransferredOptions;
  @Input()
  propertyTransferredResults: RolloverPropertyTransferredResult;

  isSectionInventoryCollapsed: boolean = false;

  @Input()
  selectedBadge: string;

}
